import {
    Box,
    IconButton,
    Menu,
    menuClasses,
    Tooltip,
    Typography,
} from '@mui/material';
import { Cog } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import useDose from '~/hooks/patient/dose/useDose';
import DoseNormalization from './DoseNormalization';
import DoseRescaler from './DoseRescaler';
import DoseOpacityModifier from '~/components/Sliders/DoseOpacityModifier';

export default function DoseSettingsDialog() {
    const { dose, setNormalizationValue } = useDose();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    return (
        <Box display="flex">
            <Tooltip title={<FormattedMessage id="doseSettings" />}>
                <IconButton
                    color="primary"
                    size="small"
                    aria-controls="dose-settings-menu"
                    aria-haspopup="true"
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    sx={{ p: 1 }}
                    data-testid="dose-settings-button"
                >
                    <Cog size={12} />
                </IconButton>
            </Tooltip>
            <Menu
                id="dose-settings-menu"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                sx={{
                    width: 'calc(240px + 8px)',
                    ml: -0.5,
                    [`& .${menuClasses.paper}`]: {
                        width: '240px',
                        marginTop: '4px',
                        padding: 2,
                    },
                }}
                MenuListProps={{ dense: true }}
            >
                <Typography fontSize={16}>
                    <FormattedMessage id="doseSettings" />
                </Typography>

                <Box display="grid" gap={1.5} mt={1}>
                    <Typography variant="body2" fontSize={11}>
                        <FormattedMessage id="doseScalingInfo" />
                    </Typography>

                    <DoseRescaler dose={dose} />
                    <Typography variant="body2" fontSize={11}>
                        <FormattedMessage id="doseNormalizationInfo" />
                    </Typography>
                    <DoseNormalization
                        dose={dose}
                        setNormalizationValue={setNormalizationValue}
                    />
                    <DoseOpacityModifier showReset={false} />
                </Box>
            </Menu>
        </Box>
    );
}
